import { createSlice } from '@reduxjs/toolkit'
import { getRoles } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState = { 
  roles: [], 
  loading: "idle",
  error: null 
}

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    clearRolesError: (state) => {
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getRoles.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [getRoles.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.roles = action.payload;
    },
    [getRoles.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const {clearRolesError} = rolesSlice.actions;
export default rolesSlice.reducer
